var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AssetMarker',_vm._g({attrs:{"asset":_vm.asset,"interactive":_vm.interactive,"is-on":_vm.isOn,"is-selected":_vm.isSelected,"visible":_vm.visible,"small":_vm.small}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }